import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=1ec480ff&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Tab.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/common/Tab.vue
// module id = 900
// module chunks = 1